import { Component, OnInit } from "@angular/core";
import { SuppliersService } from "../../services/suppliers.service";
import { Urls } from "../../../../config/urls.config";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { ErrorHandlerService } from "src/app/shared/error-handler.service";
import { LoggerService } from "../../../../shared/logger.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-suppliers-list",
  templateUrl: "./suppliers-list.component.html",
  styleUrls: ["./suppliers-list.component.css"],
})
export class SuppliersListComponent implements OnInit {
  suppliersHeaders = ["Id", "Foto", "Nome", "Cargo", "Permissão"];
  suppliersData = [];

  loading: boolean = true;
  deleting: boolean = false;

  userRole: string[] = [];
  isAdmin: boolean = false;
  isSupervisor: boolean = false;
  isManager: boolean = false;
  isUser: boolean = false;

  constructor(
    private supplierService: SuppliersService,
    private toast: ToastrService,
    private authService: AuthService,
    public router: Router,
    private errorHandlerService: ErrorHandlerService,
    private logger: LoggerService
  ) {}

  ngOnInit(): void {
    this.getUserRoles();
    this.loadSuppliers();
  }

  private getUserRoles(): void {
    this.authService.getUserRoles().forEach((role) => {
      this.logger.debug("User role", role.name);
      switch (role.name) {
        case "ROLE_ADMIN":
          this.isAdmin = true;
          break;
        case "ROLE_MANAGER":
          this.isManager = true;
          break;
        case "ROLE_SUPERVISOR":
          this.isSupervisor = true;
          break;
        case "ROLE_USER":
          this.isUser = true;
          break;
        default:
          this.isUser = true;
      }
    });
  }

  private loadSuppliers(): void {
    this.supplierService.findAllByContractType("Supplier").subscribe({
      next: (suppliers) => {
        if (suppliers != null) {
          suppliers.forEach((response) => {
            response.picture = response.picture == null ? Urls.getDefaultPictureS3() : response.picture;
            let accessType =
              response.accessType == "Manager" ? "Gerente" : response.accessType == "User" ? "Usuário" : "Supervisor";
            const supplier = [response.id, response.picture, response.name, response.responsibilityName, accessType];
            this.suppliersData.push(supplier);
          });
        }
      },
      error: (error) => this.errorHandlerService.handle(error, "Erro ao carregar os Prestadores de Serviços"),
      complete: () => (this.loading = false),
    });
  }

  // Métodos para emitir os eventos de ação
  onEdit(employee: any) {
    const id = employee[0];
    this.router.navigate(["/suppliers/edit/", id]);
  }

  public onDelete(row: any): void {
    const id = row[0];
    const name = row[2];
    Swal.fire({
      title: "Desativar Prestador de Serviço",
      html: `
        <div class="delete-dialog-content">
          <div class="delete-icon-wrapper">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#f44336"/>
            </svg>
          </div>
          <p class="delete-dialog-title">Tem certeza que deseja desativar este prestador de serviço?</p>
          <div class="delete-dialog-employee-info">
            <strong>${name}</strong>
          </div>
          <p class="delete-dialog-warning">Esta ação não pode ser desfeita. O prestador será desativado e não poderá mais acessar o sistema.</p>
        </div>
      `,
      icon: "warning",
      iconColor: "#f44336",
      showCancelButton: true,
      confirmButtonText: "Sim, desativar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#f44336",
      cancelButtonColor: "#6c757d",
      buttonsStyling: true,
      reverseButtons: true,
      focusCancel: true,
      customClass: {
        popup: "delete-dialog-popup",
        title: "delete-dialog-swal-title",
        htmlContainer: "delete-dialog-html-container",
        confirmButton: "delete-dialog-confirm-button",
        cancelButton: "delete-dialog-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleting = true;
        this.supplierService.delete(id).subscribe({
          next: () => {
            Swal.fire({
              title: "Desativado!",
              text: `O prestador de serviço ${name} foi desativado com sucesso.`,
              icon: "success",
              confirmButtonColor: "#4caf50",
              confirmButtonText: "OK",
              timer: 3000,
              timerProgressBar: true,
            });
            this.deleting = false;
            window.location.reload();
          },
          error: (error) => {
            this.deleting = false;
            Swal.fire({
              title: "Erro!",
              text: "Não foi possível desativar o prestador de serviço. Tente novamente.",
              icon: "error",
              confirmButtonColor: "#f44336",
              confirmButtonText: "OK",
            });
            this.errorHandlerService.handle(error, "Erro ao deletar fornecedor(a) selecionado(a).");
          },
        });
      }
    });
  }

  onView(row: any) {
    this.logger.debug("Viewing supplier", row);
  }
}
